/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { business_area } from '../models/business_area';
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { vw_business_area } from '../models/vw_business_area';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BusinessAreaService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postBusinessAreaDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/business_area/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of Business Areas
     * @returns vw_business_area A list of teams
     * @throws ApiError
     */
    public getBusinessAreas(): CancelablePromise<Array<vw_business_area>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/business_areas',
        });
    }

    /**
     * Get business_area by id
     * @returns vw_business_area The business_area data
     * @throws ApiError
     */
    public getBusinessArea({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_business_area> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/business_area/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Business Area not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a business_area by id
     * @returns any Business Area deleted successfully
     * @throws ApiError
     */
    public deleteBusinessArea({
        id,
    }: {
        /**
         * The business_area id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/business_area/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Business Area not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new Business Area
     * @returns any Business Area created successfully
     * @throws ApiError
     */
    public postBusinessArea({
        requestBody,
    }: {
        requestBody: business_area,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/business_area',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Business Area
     * @returns any Business Area updated successfully
     * @throws ApiError
     */
    public putBusinessArea({
        requestBody,
    }: {
        requestBody: business_area,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/business_area',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Business Area not found`,
                500: `Internal server error`,
            },
        });
    }

}
